import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Dodaj kolejny samochód.", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "container select-car-header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "big" }, "Wybierz samochód,", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "light" }, "Sprawdź koszt naprawy", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "container mt-2"
}
const _hoisted_9 = { class: "d-flex justify-content-end has-account" }
const _hoisted_10 = {
  key: 0,
  class: "gray"
}
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = {
  key: 3,
  class: "container mt-4"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_by_vin = _resolveComponent("select-by-vin")!
  const _component_select_by_type = _resolveComponent("select-by-type")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_additional_info = _resolveComponent("additional-info")!

  return (_openBlock(), _createElementBlock("div", {
    id: "selecting-car",
    class: _normalizeClass(["select-car", { 'first-time': !_ctx.isAddingNext }])
  }, [
    (_ctx.isAddingNext)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7)),
    (_ctx.wantSelectCar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (!_ctx.hasNotVin)
            ? (_openBlock(), _createBlock(_component_select_by_vin, {
                key: 0,
                onToggleVinSelect: _ctx.toggleVinSelect,
                onCarAdded: _ctx.selectionFinished
              }, null, 8, ["onToggleVinSelect", "onCarAdded"]))
            : (_openBlock(), _createBlock(_component_select_by_type, {
                key: 1,
                onToggleVinSelect: _ctx.toggleVinSelect,
                onCarAdded: _ctx.selectionFinished,
                "adding-next": _ctx.isAddingNext
              }, null, 8, ["onToggleVinSelect", "onCarAdded", "adding-next"])),
          _createElementVNode("div", _hoisted_9, [
            (!_ctx.user)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createTextVNode("Mam konto - "),
                  _createVNode(_component_router_link, { to: { name: 'login' } }, {
                    default: _withCtx(() => [
                      _createTextVNode("Zaloguj")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_ctx.isAddingNext)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-sm btn-light ms-1",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectionFinished && _ctx.selectionFinished(...args)))
                  }, " Anuluj "))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.wantSelectCar = true))
              }, " Kliknij aby wybrać samochód ")
            ])
          ])
        ])),
    _createVNode(_component_additional_info)
  ], 2))
}